import { render, staticRenderFns } from "./i-posts.vue?vue&type=template&id=1102b688&scoped=true&"
import script from "./i-posts.vue?vue&type=script&lang=js&"
export * from "./i-posts.vue?vue&type=script&lang=js&"
import style0 from "./i-posts.vue?vue&type=style&index=0&id=1102b688&lang=css&scoped=true&"
import style1 from "./i-posts.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1102b688",
  null
  
)

export default component.exports